module.exports = __webpack_public_path__ + "img/PS.7d2c9da4.jpg";